/* eslint no-console: 0 */
/* eslint no-unused-expressions: 0 */
/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useEffect, useState } from 'react'
import { I18n } from 'aws-amplify'
import { useHistory, useLocation } from 'react-router-dom'
import { useMe } from '../../../../../presentation/contexts/me'
import { usePage } from '../../../../../presentation/contexts/page'
import { useSnackbar } from '../../../../../presentation/contexts/snackbar'
import { ChargeType, ServiceType } from '../../../../../presentation/enums/stablishment-tables'
import { removeEmptyFields } from '../../../../../presentation/helpers/helper-object'
import { priceToNumber } from '../../../../../presentation/helpers/helper-price'
import { stringToBoolean } from '../../../../../presentation/helpers/helper-string'
import TableEditor from '../../../../../presentation/pages/dashboard/tables/cadastre/editor'
import { apiToForm, makeStablishmentTables, makeStablishmentTablesQRCode } from '../../../../usecases/stablishment-tables/load-stablishment-tables'
import { useLoading } from '../../../../../presentation/contexts/loading'

const MakeTableEditor = () => {
  const { me } = useMe()
  const { setHeader } = usePage()
  const { setIsShowing, setText, setType } = useSnackbar()
  const { onSetLoading } = useLoading()
  const history = useHistory()
  const location = useLocation()
  const [initialTables, setInitialTables] = useState<any | null>(null)
  const [currentTable, setCurrentTable] = useState<any>(null)
  const [data, setData] = useState<any>(null)
  const [isToUpdate, setIsToUpdate] = useState(false)
  const [canAddMoreTable, setCanAddMoreTable] = useState(false)
  const [generateQRCodeLoading, setGenerateQRCodeLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string | null>('')

  const fetchTables = async (items: any) => {
    try {
      if (items && items.length > 0) {
        const response = apiToForm({ ...items })
        setInitialTables({ ...response })
        setIsToUpdate(true)
      }
    } catch (error) {
      console.log(error)
    }
  }

  // Get table location and set form with necessary
  useEffect(() => {
    const { items } = location.state as any
    (async () => {
      onSetLoading(true)
      setHeader({
        title: items ? 'Editar mesa' : 'Nova mesa',
        goTo: '/dashboard/tables',
      })

      fetchTables(items.filter((item: any) => item))
      onSetLoading(false)
    })()
  }, [me, setHeader, location.state])

  useEffect(() => {
    (async () => {
      if (!me) return
      const { tablesAmount, tableAmountLimit } = location.state as any

      const tableAmount = (tablesAmount ?? 0) + data.tables.length
      const canShow = tableAmount < (tableAmountLimit ?? 1)
      setCanAddMoreTable(canShow)
    })()
  }, [me, data])

  const dataForm = [
    {
      items: [
        {
          component: 'InputGroup',
          inputs: [
            {
              name: 'name',
              component: 'Input',
              value: '',
              required: true,
              type: 'number',
              validations: 'inputRequired',
              placeholder: 'Digite aqui',
              title: 'Nome da mesa',
              label: 'Nome da mesa',
              styleContainer: { marginBottom: '10px', width: '100%' },
            },
            {
              component: 'InputSwitch',
              name: 'isActive',
              label: 'Ativo',
              title: 'Ativo',
              value: '',
              styleContainer: { marginBottom: '10px', width: '30%' },
            },
          ],
        },
        {
          component: 'InputGroup',
          inputs: [
            {
              name: 'hasServiceCharge',
              component: 'InputRadio',
              required: true,
              value: '',
              title: 'Deseja inserir taxa de serviço?',
              label: 'Deseja inserir taxa de serviço?',
              options: [{ label: 'Sim', value: 'true' }, { label: 'Não', value: 'false' }],
            },
            {
              name: 'serviceType',
              component: 'InputRadio',
              required: true,
              value: '',
              title: 'Qual tipo de serviço?',
              label: 'Qual tipo de serviço?',
              options: [
                { label: 'Atendimento', value: ServiceType.ATTENDANCE },
                { label: 'Couver', value: ServiceType.COVER },
              ],
              dependencies: [{ name: 'hasServiceCharge', value: 'true' }],
            },
          ],
        },
        {
          component: 'InputGroup',
          inputs: [
            {
              name: 'chargeType',
              component: 'InputRadio',
              required: true,
              value: '',
              title: 'A taxa será fixa ou percentual?',
              label: 'A taxa será fixa ou percentual?',
              dependencies: [{ name: 'serviceType', value: String(ServiceType.ATTENDANCE) }],
              options: [
                {
                  label: 'Percentual',
                  value: ChargeType.PERCENTAGE,
                },
                {
                  label: 'Fixa',
                  value: ChargeType.FIXED,
                },
              ],
            },
            {
              component: 'Input',
              name: 'chargeAmountFixed',
              required: true,
              dependencies: [
                { name: 'chargeType', value: String(ChargeType.FIXED) },
                { name: 'serviceType', value: String(ServiceType.COVER) },
              ],
              label: 'Digite o valor (R$)',
              title: 'Digite o valor (R$)',
              mask: 'CURRENCY',
              type: 'text',
              value: '',
              placeholder: 'Digite aqui',
            },
            {
              component: 'Input',
              name: 'chargeAmountPercentage',
              required: true,
              dependencies: [
                { name: 'chargeType', value: String(ChargeType.PERCENTAGE) },
              ],
              label: 'Digite o percentual (%)',
              title: 'Digite o percentual (%)',
              type: 'number',
              value: '',
              placeholder: 'Digite aqui',
            },
          ],
        },
      ],
    },
  ]

  const formatTableToSubmit = (item: any) => {
    const chargeAmount = item.chargeType === String(ChargeType.PERCENTAGE)
      ? item.chargeAmountPercentage && Number(item.chargeAmountPercentage)
      : item.chargeAmountFixed && priceToNumber(item.chargeAmountFixed)

    const formattedItem = {
      name: +item.name,
      hasServiceCharge: stringToBoolean(item.hasServiceCharge) || false,
      isActive: item.isActive || false,
      serviceType: item.serviceType || null,
      chargeType: item.chargeType || null,
      chargeAmount: chargeAmount || null,
      id: item.id || null,
    }

    if (formattedItem.serviceType) {
      formattedItem.serviceType = Number(formattedItem.serviceType)
    }
    if (formattedItem.chargeType) {
      formattedItem.chargeType = Number(formattedItem.chargeType)
    }

    return removeEmptyFields(formattedItem)
  }

  const generateQRCode = async (table: any) => {
    try {
      if (!me) return
      if (!generateQRCodeLoading) {
        setGenerateQRCodeLoading(true)
        const stablishmentId = me.stablishments[0].id
        const { stablishmentTable } = await makeStablishmentTablesQRCode(
          stablishmentId,
          table.id,
        ).post()
        setCurrentTable(stablishmentTable)
        fetchTables([stablishmentTable])
      }
    } catch (error) {
      console.log(error)
    } finally {
      setGenerateQRCodeLoading(false)
    }
  }

  const onSubmit = async (values:any): Promise<void> => {
    const itemToSubmit = values.tables.map((table: any) => formatTableToSubmit(table))

    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      if (isToUpdate) {
        await makeStablishmentTables(stablishmentId).patch(itemToSubmit[0].id, itemToSubmit[0])
      } else {
        await makeStablishmentTables(stablishmentId).post(itemToSubmit)
      }

      setType('success')
      setText('Salvo com sucesso!')
      setIsShowing(true)
      history.push('/dashboard/tables')
    } catch (error: any) {
      const msg = I18n.get(error.name) as string
      setErrorMessage(msg)
    }
  }

  return (
    <TableEditor
      generateQRCode={generateQRCode}
      generateQRCodeLoading={generateQRCodeLoading}
      dataForm={dataForm}
      currentTable={currentTable}
      canAddMoreTable={canAddMoreTable}
      setCurrentTable={setCurrentTable}
      onSubmit={onSubmit}
      initialData={initialTables}
      setData={setData}
      isToUpdate={isToUpdate}
      errorMessage={errorMessage}
    />
  )
}

export default MakeTableEditor
